var _defs, _path, _path2, _rect, _path3, _path4, _path5, _polyline, _polyline2, _line, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a966096a-5000-4345-8bf7-cc69a025b265",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e4f17d4c-0b2d-4d93-b0af-ee2564f7c143,.fe62bba0-1f02-4574-9a91-64d28138f549{fill:none;}.bf457ebf-c694-4f2c-95db-618280389d88,.e4f17d4c-0b2d-4d93-b0af-ee2564f7c143{stroke:#8e8e8e;}.bf457ebf-c694-4f2c-95db-618280389d88,.e4f17d4c-0b2d-4d93-b0af-ee2564f7c143,.fe62bba0-1f02-4574-9a91-64d28138f549{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.b645e8bf-7aec-40f8-a820-d99695291738,.bf457ebf-c694-4f2c-95db-618280389d88{fill:#f9af00;}.ed60c32e-6b03-411d-a92f-e680fd6b5e82{fill:#fff;}.fe62bba0-1f02-4574-9a91-64d28138f549{stroke:#645346;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "jpg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "e4f17d4c-0b2d-4d93-b0af-ee2564f7c143",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bf457ebf-c694-4f2c-95db-618280389d88",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b645e8bf-7aec-40f8-a820-d99695291738",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ed60c32e-6b03-411d-a92f-e680fd6b5e82",
    d: "M46.4,62.2h1.3V69c0,2.7-1.3,3.5-3.1,3.5a3.5,3.5,0,0,1-1.4-.3l.2-1,1.1.2c1.2,0,1.9-.5,1.9-2.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ed60c32e-6b03-411d-a92f-e680fd6b5e82",
    d: "M49.9,62.3h2.5a4.3,4.3,0,0,1,2.8.8,2.9,2.9,0,0,1,.9,2.1,3.3,3.3,0,0,1-.8,2.2,4.3,4.3,0,0,1-3.1,1.1h-1v4H49.9Zm1.3,4.9h1c1.6,0,2.6-.7,2.6-2.1s-1-2-2.4-2H51.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ed60c32e-6b03-411d-a92f-e680fd6b5e82",
    d: "M65.5,71.9a9.9,9.9,0,0,1-3.1.5,4.7,4.7,0,0,1-5.2-5.1,5.1,5.1,0,0,1,5.5-5.2,5.9,5.9,0,0,1,2.5.5l-.3,1a5.7,5.7,0,0,0-2.2-.4,3.8,3.8,0,0,0-4.1,4.1,3.7,3.7,0,0,0,3.9,4,5.4,5.4,0,0,0,1.7-.2v-3h-2V67h3.3Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "fe62bba0-1f02-4574-9a91-64d28138f549",
    points: "37.1 24.3 63.2 24.3 63.2 53.5 30.6 53.5 30.6 32.7"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "fe62bba0-1f02-4574-9a91-64d28138f549",
    points: "31.1 53.5 42.7 41.9 53.9 53"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "fe62bba0-1f02-4574-9a91-64d28138f549",
    x1: 48,
    y1: 47.1,
    x2: 62.6,
    y2: 32.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fe62bba0-1f02-4574-9a91-64d28138f549",
    cx: 48,
    cy: 33.8,
    r: 3.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.95d04ef210773311d6f1338fd6c116b4.svg";
export { ForwardRef as ReactComponent };